import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbbd228e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card card-empty my-2"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-body d-flex justify-content-center align-items-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่พบข้อมูล ")
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "draggable" }
const _hoisted_5 = { class: "card card-sub my-2" }
const _hoisted_6 = { class: "card-body py-2" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-auto carousel-box" }
const _hoisted_9 = ["href", "data-lightbox"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "list-group list-group-flush" }
const _hoisted_13 = { class: "list-group-item text-truncate" }
const _hoisted_14 = { class: "list-group-item text-truncate" }
const _hoisted_15 = { class: "col-1 d-flex align-items-center" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!
  const _component_Draggable = _resolveComponent("Draggable")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        (_ctx.carousels.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
          : (_openBlock(), _createBlock(_component_Draggable, _mergeProps({
              key: 1,
              list: _ctx.carousels,
              "item-key": "sequence",
              class: "no-bullets",
              tag: "ul"
            }, _ctx.dragOptions, {
              "ghost-class": "ghost",
              onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dragging = true)),
              onEnd: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dragging = false)),
              onChange: _ctx.onMoved
            }), {
              item: _withCtx(({ element }) => [
                _createElementVNode("li", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("a", {
                            href: element.image,
                            "data-lightbox": `carousel-${element.id}`
                          }, [
                            _createElementVNode("img", {
                              class: "img-responsive img-carousel",
                              alt: "Carousel Photo",
                              src: element.image
                            }, null, 8, _hoisted_10)
                          ], 8, _hoisted_9)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("ul", _hoisted_12, [
                            _createElementVNode("li", _hoisted_13, _toDisplayString(element.title), 1),
                            _createElementVNode("li", _hoisted_14, _toDisplayString(element.description), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("button", {
                            class: "btn btn-primary btn-edit",
                            onClick: ($event: any) => (_ctx.editClick(element.id))
                          }, [
                            _hoisted_17,
                            _createTextVNode("แก้ไข ")
                          ], 8, _hoisted_16)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 16, ["list", "onChange"]))
      ], 64))
}